// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".overNone[data-v-115dbf4b]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
module.exports = exports;
